import axios from "axios";

const trimTrailingSlash = (value) => (value || "").replace(/\/+$/, "");

const joinUrl = (base, path = "") => {
  const cleanBase = trimTrailingSlash(base);
  const cleanPath = `${path || ""}`.replace(/^\/+/, "");
  return cleanPath ? `${cleanBase}/${cleanPath}` : cleanBase;
};

const repeatLastPathSegment = (base) => {
  const cleanBase = trimTrailingSlash(base);
  const lastSegment = cleanBase.split("/").filter(Boolean).pop();

  if (!cleanBase || !lastSegment) return cleanBase;

  const doubledSuffix = `/${lastSegment}/${lastSegment}`;
  return cleanBase.endsWith(doubledSuffix)
    ? cleanBase
    : `${cleanBase}/${lastSegment}`;
};

const apiBaseUrl = process.env.REACT_APP_BASE_API_URL || "/api";
const modelsBaseUrl = process.env.REACT_APP_MODELS_API_URL || "/models";
const reportsBaseUrl = process.env.REACT_APP_REPORTS_API_URL || "/reports";

export const modelsProxyUrl = (path = "") =>
  joinUrl(repeatLastPathSegment(modelsBaseUrl), path);

export const reportsProxyUrl = (path = "") => joinUrl(reportsBaseUrl, path);

export const api = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});

export const reportsApi = axios.create({
  baseURL: reportsProxyUrl(),
  withCredentials: true,
});

export const modelsApi = axios.create({
  baseURL: modelsProxyUrl(),
  withCredentials: true,
});

let responseInterceptorIds = [];
let isHandlingUnauthorized = false;

const ejectResponseInterceptors = () => {
  responseInterceptorIds.forEach(({ client, id }) => {
    client.interceptors.response.eject(id);
  });
  responseInterceptorIds = [];
};

export const setupInterceptors = (logout) => {
  ejectResponseInterceptors();

  const onError = async (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?._skipUnauthorizedLogout &&
      !isHandlingUnauthorized
    ) {
      isHandlingUnauthorized = true;
      try {
        await logout();
      } finally {
        isHandlingUnauthorized = false;
      }
    }

    return Promise.reject(error);
  };

  responseInterceptorIds = [api, reportsApi, modelsApi].map((client) => ({
    client,
    id: client.interceptors.response.use((res) => res, onError),
  }));

  return ejectResponseInterceptors;
};

export default api;
